import React, { Suspense } from 'react';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import CloseIconMui from '@mui/icons-material/Close';
import Toolbar from '@mui/material/Toolbar';
import Dialog from '@mui/material/Dialog';
import Slide from '@mui/material/Slide';
import { Preloader } from '#component/preloader';
import ShipmentMap from '#component/dashboard/map';
import { DialogAppBar, CloseIcon, MapCnt } from '#component/dashboard/styles';

const Transition = React.forwardRef((props, ref) => (
  <Slide direction="down" ref={ref} {...props} />
));

export const MapDialog = props => {
  const {
    tab,
    data,
    open,
    loading,
    handleClose,
    identifiersMap,
    mapDataLoading,
    defaultDevices,
    locations,
    destinations,
    clickDevices
  } = props;

  return (
    <Dialog
      TransitionComponent={Transition}
      onClose={handleClose}
      open={open}
      fullScreen
      className="cluster"
    >
      <DialogAppBar>
        <Toolbar>
          <CloseIcon
            as={IconButton}
            aria-label="close"
            color="inherit"
            edge="start"
            onClick={handleClose}
          >
            <CloseIconMui />
          </CloseIcon>
          <Typography variant="h5">
            MAP
          </Typography>
        </Toolbar>
      </DialogAppBar>
      {identifiersMap[tab] && !loading ? (
        <Suspense fallback={<Preloader />}>
          <MapCnt>
            {mapDataLoading && data[tab] ? (
              <Preloader className="mapPreloader" />
            ) : (
              <ShipmentMap
                isMobile={true}
                zoomLastLocation={false}
                data={data[tab]}
                defaultDevices={defaultDevices}
                locations={locations}
                destinations={destinations}
                clickDevices={clickDevices}
              />
            )}
          </MapCnt>
        </Suspense>
      ) : (
        <Preloader />
      )}
    </Dialog>
  );
};
